module.exports = __webpack_public_path__ + "media/images/shieldCheckmark-29ae626a2d60a353cd5e1d0af5ab13c6.svg";